import styled from 'styled-components';

export const HiddenDiv = styled.div`
  .hidden {
    display: none;
  }
`;
